import React, { useEffect, useState } from "react";
import Constants from "../../utils/constants";
import moment from "moment";
import EventSeatIcon from '@material-ui/icons/EventSeat';

import "./styles.scss";
import { langStringConvertor } from "../../utils/utils";
import { Typography } from "@material-ui/core";

const { LANGUAGES } = Constants;
const { minute, scheduleText, arrivingText, nextText, noScheduled, youAreHere } = LANGUAGES;

const StationEta = (props) => {
  const { stationName, time, lang, index, message, etaDisplayMethod, themeColour, isNearestStop, showLicensePlate, vehicleLocations } = props;
  const [language, setLanguage] = useState(props.language);

  useEffect(() => {
    setLanguage(lang);
  }, [lang]);

  const renderTimeHeader = (time, index) => {
    if (time) {
      if (time.vehicle) {
        if (index === 0) {
          return <span className="title">{arrivingText[language]}</span>;
        } else {
          return <span className="title">{nextText[language]}</span>;
        }
      } else {
        return <span className="title">{scheduleText[language]}</span>;
      }
    } else {
      return <span className="title">-</span>;
    }
  };

  const renderPcsCount = (vehicle) => {
    if (vehicle?.pcs?.front?.in !== undefined && vehicle?.pcs?.front?.out !== undefined) {
      const count = (vehicle.seatCount || 16) - ((vehicle?.pcs?.front?.in - vehicle?.pcs?.front?.out) || 0);
      return <span style={{ marginLeft: "10px", display: "inline-flex" }}><EventSeatIcon/>{LANGUAGES.seatsLeft[lang]} <span style={{ marginLeft: "5px" }}>{count}</span></span>
    }
  }

  const renderTime = (time, index) => {
    let timeText = null;
    let timeTitle = null;
    let shouldShowUnit = false;
    let showSmallerText = false;
    if (time && typeof time.diff === "number") {
      if (time.diff > 90) {
        shouldShowUnit = false;
        showSmallerText = true;
        // show exact time here
        timeText = moment(time.timestamp).format("HH:mm");
      } else {
        shouldShowUnit = true;
        showSmallerText = false;
        // show minute here
        timeText = Math.round(time.diff);
        timeTitle = moment(time.timestamp).format("HH:mm");
      }
      return (
        <>
          <span
            className="value"
            title={timeTitle}
            style={{
              color: `${time.vehicle ? themeColour : "#AAAAAA"}`,
              fontSize: showSmallerText ? "20px" : "28px",
            }}
          >
            {timeText}
          </span>
          {shouldShowUnit && <span className="unit">
            {minute[language]}
            {renderPcsCount(vehicleLocations?.[time.vehicle])}
          </span>}
          <div>
            {time[`remarks_${langStringConvertor(language)}`] && (
              <span className="remarks">
                {`(${time[`remarks_${langStringConvertor(language)}`]})`}
              </span>
            )}
            {(showLicensePlate && vehicleLocations?.[time.vehicle]?.license_plate) && <span className="remarks">{`(${vehicleLocations?.[time.vehicle]?.license_plate})`}</span>}
          </div>
        </>
      );
    } else {
      return (
        <>
          <span className="value">-</span>
          <span className="unit">{minute[language]}</span>
        </>
      );
    }
  };

  // console.log(index, time.diff, time.remarks_en);
  return (
    <div className="station-eta" key={`${stationName}`}>
      <div className="title">
        <div className="name">
          <span className={language}>{stationName}</span>
          {!!(message) && (
            <span className={`message-${language}`}>{`${message}`}</span>
          )}
          {!!isNearestStop && (
            <span className={`message-${language}`}>{youAreHere[lang]}</span>
          )}
        </div>
      </div>
      {time ? (
        // {/* Eta Time  */ }
        <div className={`${etaDisplayMethod === "column" ? "eta-col" : "eta"}`}>
          {index === 0 &&
          time?.find((el) => el.eta_seq === 1).diff === 0 &&
          !time?.find((el) => el.eta_seq === 1).remarks_en ? (
            <></>
          ) : (
            <div className="eta-block coming">
              {renderTimeHeader(
                time?.find((el) => el.eta_seq === 1),
                0
              )}
              <div className="time">
                {renderTime(
                  time?.find((el) => el.eta_seq === 1),
                  0,
                  themeColour
                )}
              </div>
            </div>
          )}
          <div className="eta-block later">
            {renderTimeHeader(
              time?.find((el) => el.eta_seq === 2),
              1
            )}
            <div className="time">
              {renderTime(
                time?.find((el) => el.eta_seq === 2),
                1,
                themeColour
              )}
            </div>
          </div>
          <div className="eta-block later">
            {renderTimeHeader(
              time?.find((el) => el.eta_seq === 3),
              2
            )}
            <div className="time">
              {renderTime(
                time?.find((el) => el.eta_seq === 3),
                2,
                themeColour
              )}
            </div>
          </div>
          {index === 0 &&
            time?.find((el) => el.eta_seq === 1).diff === 0 &&
            !time?.find((el) => el.eta_seq === 1).remarks_en && (
              <div className="eta-block later">
                {renderTimeHeader(
                  time?.find((el) => el.eta_seq === 3),
                  2
                )}
                <div className="time">
                  {renderTime(
                    time?.find((el) => el.eta_seq === 4),
                    3,
                    themeColour
                  )}
                </div>
              </div>
            )}
        </div>
      ) : (
        <div className="eta">
          <div className="eta-block coming">
            <div className="time"></div>
          </div>
          <div className="eta-block later">
            <div className="time"></div>
          </div>
          <div className="eta-block later">
            <div className="time">
              <span
                className="value"
                style={{
                  color: "#AAAAAA",
                  fontSize: "20px",
                }}
              >
                {noScheduled[language]}
              </span>
            </div>
          </div>
        </div>
      )}
      <hr />
    </div>
  );
};

export default StationEta;
